import $ from 'jquery';
import closeAllMenus from '../../core/INF-closeAllMenus';
import adjustPositioning from './adjustPositioning';

export default function(e) {
  let $modal;
  let hash;

  if (e.preventDefault) {
    e.preventDefault();
    
    // Get modal from data attr first
    $modal = $($(e.currentTarget).data('openModal'));    

    // Check href next
    if ($modal.length === 0) {
      hash = $(e.currentTarget).attr('href');
      $modal = $(hash);
    }

    // Still no modal? Nothing to do
    if ($modal.length === 0) {
      return false;
    }
  } else {
    // This isn't an event, we're passing a modal manually as "e"
    $modal = e; // eslint-disable-line shopify/jquery-dollar-sign-reference
  }

  $(document).trigger('modalWillOpen', $modal);

  closeAllMenus();

  adjustPositioning($modal);
  $('[data-state]').addClass('State--modal-open');
  $modal.addClass('Modal--open');

  if (hash) {
    window.location.hash = hash;
  }
  
  $(document).trigger('scroll');
  return $(document).trigger('modalDidOpen', $modal);
}